import React, { useEffect, useState } from "react";
import { useSocket } from "context/SocketContext";
import { useTranslation } from "react-i18next";

const ServerStatusUI: React.FC = () => {
  const { isConnected, reconnect } = useSocket();
  const { t } = useTranslation();
  const [showUI, setShowUI] = useState(false);
  const [hasEverConnected, setHasEverConnected] = useState(false);

  useEffect(() => {
    const timer = setTimeout(() => {
      setShowUI(true);
    }, 2000);

    return () => clearTimeout(timer);
  }, []);

  // 최초 연결 추적
  useEffect(() => {
    if (isConnected && !hasEverConnected) {
      setHasEverConnected(true);
    }
  }, [isConnected, hasEverConnected]);

  // 아직 한 번도 연결된 적이 없으면 에러 UI를 표시하지 않음
  if (!showUI || !hasEverConnected) {
    return null;
  }

  return (
    <div
      className={`fixed bottom-0 left-0 right-0 z-50 transition-all duration-300 transform ${
        isConnected ? "translate-y-full" : "translate-y-0"
      }`}
    >
      <div className="bg-red-500 text-white px-4 py-2 flex items-center justify-between shadow-lg">
        <div className="flex items-center space-x-2">
          <i className="fas fa-exclamation-circle" />
          <span>{t("serverDisconnected")}</span>
        </div>
        <div className="flex items-center space-x-2">
          <div className="px-3 py-1 bg-white/10 text-white rounded flex items-center space-x-2">
            <div className="animate-spin">
              <i className="fas fa-circle-notch" />
            </div>
            <span>{t("reconnecting")}</span>
          </div>
          <button
            onClick={reconnect}
            className="px-3 py-1 bg-white/20 hover:bg-white/30 text-white rounded transition-colors"
          >
            <i className="fas fa-redo mr-1" />
            {t("retry")}
          </button>
        </div>
      </div>
    </div>
  );
};

export default ServerStatusUI;
